<template>
    <b-row class="m-2">
        <b-col v-if="loaded === false">
            <template>
                <div class="OTloading">
                    <div class="OTloader"></div>
                </div>
            </template>
        </b-col>
        <b-col v-else>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
            <otif-textInput
                v-bind:label="ecmResourceStrings.lblRepositoryID"
                :required="true"
                v-model="$v.form.repositoryId.$model"   
                :disabled="true"/>
            <otif-textInput
                v-bind:label="ecmResourceStrings.lblRepositoryType"
                v-model="repository_type"
                :required="true"
                :disabled="true"/>
            <otif-textarea 
                v-bind:label="ecmResourceStrings.lblDescription"
                v-model="$v.form.description.$model"
                @input="onchangedescription"/>
        </b-col>
    </b-row>
</template>

<script>

import axios from 'axios';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { numericval } from '../../../utils/validatorECM.js';
import { showMessage } from '../../../utils/commonECM.js';


export default {

    props: ['ecmRepository', 'realConfigurations'],
    
    components: {
         ECMErrorDialog,
    },
    mixins: [ validationMixin ],

    watch: {
        parent() {
            this.refresh();
        },
    },

    data() {
        return {         
            seen: false,
            loaded: false,
            messageDlg: false,
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            repository_types: [],
            repository_type: '',
             form: {
                repositoryId: '',
                description:''
            },
        }
    },

    validations: {
        form: {
            repositoryId: { required, numericval },
            repository_type: { required },
            description:{},
        }
    },

    methods: {
        onchangedescription($e) {
            this.ecmRepository.attributes.description=$e;
        },
    },
  
    mounted() {
            var breadcrumbs = [{
                name: 'settings',
                meta: { label: 'Settings' }
            },        {
                name: 'ecm-repositories',
                meta: { label: 'Repositories' }
            },{
                name: 'rdbms-repo',
                meta: { label: 'Update RDBMS Repository' }
            }];
            this.$store.commit('breadcrumbs', breadcrumbs);
      
    },

    created() {
        var that = this;
        if(that.ecmRepository.attributes)
        {
            that.repository_type=that.ecmRepository.attributes.repositoryType;
            that.form.description=that.ecmRepository.attributes.description;
            that.form.repositoryId=that.ecmRepository.attributes.repositoryId;
        }
        that.loaded = true;
    },
}
</script>